export { View as PartnerLogos } from './view'
